/** @jsx jsx */

import * as React from 'react';

import { css, jsx } from '@emotion/react';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DateTime } from 'luxon';

import { COLORS } from '@root/colors';

import { IDispatchOrder } from '@admin/types/dispatch_order';

import { useScale } from './order_gantt';

export const ExpectedStartTimeCaret = () => <FontAwesomeIcon color={COLORS.red} icon={faCaretDown} size="2x" />;

export const ExpectedStartTime: React.FC<{ order: IDispatchOrder }> = ({ order: { expectedStartTime } }) => {
  const scale = useScale();
  if (!expectedStartTime) {
    return null;
  }

  const time = DateTime.fromISO(expectedStartTime);
  const left = scale(time);

  const position = css`
    position: absolute;
    left: ${left}%;
    bottom: 30%;
    margin-left: -7.5px;
  `;

  return (
    <div css={position}>
      <ExpectedStartTimeCaret />
    </div>
  );
};
